import request from '@/utils/request'

let cardApi = {
  /*名片列表*/
  cardList(data, errorback) {
    return request._post('/shop/plus.card.CardList/index', data, errorback);
  },
  /*添加名片*/
  addCard(data, errorback) {
    return request._post('/shop/plus.card.CardList/add', data, errorback);
  },
  /*获取名片数据*/
  getCard(data, errorback) {
    return request._get('/shop/plus.card.CardList/edit', data, errorback);
  },
  /*保存名片*/
  saveCard(data, errorback) {
    return request._post('/shop/plus.card.CardList/edit', data, errorback);
  },
  /*删除名片*/
  delCard(data, errorback) {
    return request._post('/shop/plus.card.CardList/delete', data, errorback);
  },
  /*查看商品*/
  seeCard(data, errorback) {
    return request._post('/shop/plus.card.CardList/see', data, errorback);
  },
  /*保存设置*/
  saveSetting(data, errorback) {
    return request._post('/shop/plus.card.Setting/index', data, errorback);
  },
  /*获取设置*/
  getSetting(data, errorback) {
    return request._get('/shop/plus.card.Setting/index', data, errorback);
  },
  /*获取供应商列表*/
  getSupplyList(data, errorback) {
    return request._get('/shop/plus.card.CardList/add', data, errorback);
  },
  /* 
  *编辑名片信息获取
  */
  getCardInfo(data, errorback) {
    return request._get('/shop/plus.card.CardList/edit', data, errorback);
  },
  editCard(data, errorback) {
    return request._post('/shop/plus.card.CardList/edit', data, errorback);
  },
  /* 查看名片码 */
  showCode(data, errorback) {
    return request._post('/shop/plus.card.CardList/showCode', data, errorback);
  },

   /* 查看名片分类 */
  categoryList(data, errorback) {
    return request._get('/shop/plus.card.Category/categoryList', data, errorback);
  },
  /* 添加名片分类 */
  addCategory(data, errorback) {
    return request._post('/shop/plus.card.Category/add', data, errorback);
  },

  editCategory(data, errorback) {
    return request._post('/shop/plus.card.Category/edit', data, errorback);
  },
  delCategory(data, errorback) {
    return request._post('/shop/plus.card.Category/delete', data, errorback);
  },
  getCategoryList(data, errorback) {
    return request._get('/shop/plus.card.CardList/getCategoryList', data, errorback);
  },
  supplyList(data, errorback) {
    return request._get('/shop/plus.card.CardAuth/index', data, errorback);
  },
  editCardAuth(data,errorback){
    return request._post('/shop/plus.card.CardAuth/edit', data, errorback);
  },
  gradelist(data,errorback){
    return request._post('/shop/plus.card.CardAuth/grade', data, errorback);
  },
  addGrade(data,errorback){
    return request._post('/shop/plus.card.CardAuth/editGrade', data, errorback);
  },
  editGrade(data,errorback){
    return request._post('/shop/plus.card.CardAuth/editGrade', data, errorback);
  },
  deletegrade(data,errorback){
    return request._post('/shop/plus.card.CardAuth/delGrade', data, errorback);
  },
  cardGradeOrderList(data,errorback){
    return request._post('/shop/plus.card.CardList/cardGradeOrderList', data, errorback);
  },
}
export default cardApi;



// WEBPACK FOOTER //
// ./src/api/card.js